import { Api } from "../api";

export const logout = async () => {
  try {
    const response = await Api.post("/logout", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.data.status === "success") {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
  } catch (error) {
    if (error.response.status == 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    localStorage.removeItem("token");
    window.location.href = "/";
  }
};
export const getMe = async () => {
  try {
    const response = await Api.get("/me", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    // console.log(response.data)
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response.status == 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    console.error("Error fetching sales data:", error);
    return []; // Return an empty array in case of an error
  }
};
